function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  filter: "url(#filter0_d)"
}, React.createElement("circle", {
  cx: 26,
  cy: 26,
  r: 16,
  fill: "white"
}), React.createElement("circle", {
  cx: 26,
  cy: 26,
  r: 15,
  stroke: "#DAE1E6",
  strokeWidth: 2
}));

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M33.9016 32.9589L19.0403 18.0976C18.9101 17.9675 18.6991 17.9675 18.5689 18.0976L18.0977 18.5689C17.9674 18.6991 17.9674 18.9101 18.0977 19.0403L20.854 21.7967C19.5379 22.8381 18.543 24.2579 18.0159 25.8978C17.9948 25.9639 17.9948 26.0354 18.0159 26.1015C19.1496 29.6294 22.3582 31.9994 25.9997 31.9994C27.424 31.9994 28.7936 31.6385 30.0166 30.9592L32.959 33.9016C33.0892 34.0318 33.3002 34.0318 33.4304 33.9016L33.9016 33.4303C34.0318 33.3002 34.0318 33.0891 33.9016 32.9589ZM25.9997 30.6661C23.4265 30.6661 21.3332 28.5728 21.3332 25.9997C21.3332 24.9868 21.6663 24.0097 22.2662 23.2089L23.7154 24.6581C23.4755 25.0608 23.3331 25.5157 23.3331 25.9996C23.3331 27.47 24.5293 28.6662 25.9997 28.6662C26.4836 28.6662 26.9386 28.5237 27.3412 28.2839L28.7904 29.733C27.9895 30.3331 27.0125 30.6661 25.9997 30.6661Z",
  fill: "black"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M25.7191 23.54C25.6667 23.6647 25.695 23.8092 25.7907 23.9049L28.0953 26.2095C28.1591 26.2733 28.2444 26.3072 28.331 26.3072C28.3746 26.3072 28.4186 26.2987 28.4602 26.2811C28.5852 26.2284 28.6659 26.1057 28.6643 25.97C28.6477 24.5094 27.4908 23.3526 26.0303 23.3359C25.8975 23.3502 25.7718 23.415 25.7191 23.54Z",
  fill: "black"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M23.6133 21.7276C23.7133 21.8279 23.8659 21.8533 23.9929 21.7927C24.6296 21.488 25.305 21.3334 26.0003 21.3334C28.5734 21.3334 30.6668 23.4268 30.6668 25.9999C30.6668 26.6952 30.5121 27.3706 30.2075 28.0073C30.1466 28.1349 30.1726 28.2869 30.2726 28.3868L31.4278 29.5421C31.4903 29.6046 31.5749 29.6397 31.6635 29.6397C31.6638 29.6397 31.6641 29.6397 31.6641 29.6397C31.753 29.6394 31.838 29.6039 31.9005 29.5411C32.8477 28.5844 33.5684 27.395 33.984 26.1018C34.0052 26.0357 34.0052 25.9641 33.984 25.898C32.8503 22.3702 29.6418 20.0001 26.0003 20.0001C25.001 20.0001 24.0189 20.1778 23.0811 20.5288C22.975 20.5685 22.8962 20.6593 22.8721 20.7703C22.8481 20.881 22.8822 20.9965 22.9623 21.0766L23.6133 21.7276Z",
  fill: "black"
});

var _ref6 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("filter", {
  id: "filter0_d",
  x: 0,
  y: 0,
  width: 52,
  height: 52,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), React.createElement("feOffset", null), React.createElement("feGaussianBlur", {
  stdDeviation: 5
}), React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
}), React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})));

var SvgOpenSideBar = function SvgOpenSideBar(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgOpenSideBar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/openSideBar.bbb2ef98.svg";
export { ForwardRef as ReactComponent };